import { render, staticRenderFns } from "./DeleteTokenDialog.vue?vue&type=template&id=06363074&"
import script from "./DeleteTokenDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteTokenDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports